/** Product identity for this SPA. */
export const APP_PRODUCT = process.env.REACT_APP_PRODUCT || 'godash';
export const PRODUCT_DISPLAY_NAME = process.env.REACT_APP_PRODUCT_DISPLAY_NAME || 'GoDash';
export const PRODUCT_PARENT_NAME = 'GoBunnyy';
